<template>
  <svg viewBox="0 0 643 211" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <linearGradient id="linear-gradient" x1="19" x2="175" y1="171" y2="171" gradientUnits="userSpaceOnUse">
        <stop stop-color="#a1b003" offset="0"/>
        <stop stop-color="#bac803" offset="1"/>
      </linearGradient>
      <linearGradient id="linear-gradient-2" x1="254" x2="410" xlink:href="#linear-gradient"/>
      <linearGradient id="linearGradient890" x1="19" x2="175" y1="171" y2="171" gradientUnits="userSpaceOnUse" xlink:href="#linear-gradient"/>
    </defs>
    <g fill="none" stroke="#a7d15e" stroke-miterlimit="10" stroke-width="3">
      <path v-if="active" class="cls-1 fix-svg-origin origin-top zoomIn" d="M96.5 165.5v-29h236v33"/>
      <path class="cls-1" d="M214.5 138V69.5H526v33M368.5 68.5v-30"/>
    </g>
    <g aria-role="button" id="boton1" class="fix-svg-origin hvr hvr-clr" @click="activate">
      <path class="cls-2" fill="#5b9b00" stroke="#beeb7b" stroke-miterlimit="10" stroke-width="3" d="M97.75 89.88h234v32h-234z"/>
      <text class="cls-5" x="169.76" y="112.36" fill="#1e1e1e" font-family="MyriadPro-BoldCond, 'Myriad Pro'" font-size="19" font-weight="700">
        Desarrolladas
      </text>
    </g>
    <g id="boton4">
      <path class="cls-2" fill="#5b9b00" stroke="#beeb7b" stroke-miterlimit="10" stroke-width="3" d="M431.25 90h188v32h-188z"/>
      <text class="cls-5" x="470.22" y="112.31" fill="#1e1e1e" font-family="MyriadPro-BoldCond, 'Myriad Pro'" font-size="19" font-weight="700">
        No desarrolladas
      </text>
    </g>
    <g id="boton2" v-if="active" class="fix-svg-origin origin-top fadeIn hvr hvr-scale hvr-clr" @click="$emit('mostrarModalFullScreen')">
      <path fill="#a1b003" stroke="#beeb7b" stroke-miterlimit="10" stroke-width="3" d="M19 155h156v32H19z"/>
      <text class="cls-5" x="60.74" y="177.81" fill="#1e1e1e" font-family="MyriadPro-BoldCond, 'Myriad Pro'" font-size="19" font-weight="700">
        Produciendo
      </text>
    </g>
    <g id="boton3" v-if="active" class="fix-svg-origin origin-top zoomIn">
      <path fill="#a1b003" stroke="#beeb7b" stroke-miterlimit="10" stroke-width="3" d="M254 155h156v32H254z"/>
      <text class="cls-5" x="281.54" y="177.81" fill="#1e1e1e" font-family="MyriadPro-BoldCond, 'Myriad Pro'" font-size="19" font-weight="700">
        No produciendo
      </text>
    </g>
    <g id="root">
      <path fill="#043" stroke="#beeb7b" stroke-miterlimit="10" stroke-width="2" d="M214 22h313v32H214z"/>
      <text x="309.08" y="44.15" fill="#fff" font-family="MyriadPro-BoldCond,Myriad Pro" font-size="19" font-weight="700">
        Reservas probadas
      </text>
    </g>
  </svg>
</template>
<script>
export default {
  data() {
    return {
      active: false
    }
  },
  methods: {
    activate(){
      var t = this.active?0:300
      this.active = true
      setTimeout(()=>{this.$emit('openModal')},t)
    }
  }
  
}
</script>


<style lang="scss" scoped>
  .hvr-clr:hover path{transition: all 250ms;  fill: lighten(#5b9b00,10%);}
  .hvr-clr:active path{transition: all 0s; fill: lighten(#5b9b00,20%);}
  .cls-1,.cls-2{fill:none;stroke:#a7d15e;stroke-miterlimit:10;stroke-width:3px}.cls-2{fill:#5b9b00;stroke:#beeb7b}.cls-5{font-size:19px;font-family:MyriadPro-BoldCond,Myriad Pro;font-weight:700;fill:#1e1e1e}.cls-6,.cls-7{letter-spacing:0}
</style>